import Network from '@/Network'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import { UpsertPermissionsRequest } from '@/Network/Types/Requests/AuthorizationRequests'
import { ModuleTypeStrategy, PermissionOption } from './ModuleTypeStrategy'

const PERMISSIONS_FOR_NEW_USERS: PermissionOption[] = [
  { label: 'Leitor Básico', value: AuthorizationRelations.BasicReader },
  { label: 'Leitor Intermediário', value: AuthorizationRelations.IntermediateReader },
  { label: 'Leitor Avançado', value: AuthorizationRelations.AdvancedReader },
  { label: 'Editor Básico', value: AuthorizationRelations.BasicEditor },
  { label: 'Editor Intermediário', value: AuthorizationRelations.IntermediateEditor },
  { label: 'Administrador de Conteúdo', value: AuthorizationRelations.ContentAdmin },
  { label: 'Administrador Geral', value: AuthorizationRelations.GeneralAdmin }
]

const PERMISSIONS_FOR_SELECT: PermissionOption[] = [
  { label: 'Proprietário', value: AuthorizationRelations.Parent, disabled: true },
  { label: 'Leitor Básico', value: AuthorizationRelations.BasicReader },
  { label: 'Leitor Intermediário', value: AuthorizationRelations.IntermediateReader },
  { label: 'Leitor Avançado', value: AuthorizationRelations.AdvancedReader },
  { label: 'Editor Básico', value: AuthorizationRelations.BasicEditor },
  { label: 'Editor Intermediário', value: AuthorizationRelations.IntermediateEditor },
  { label: 'Administrador de Conteúdo', value: AuthorizationRelations.ContentAdmin },
  { label: 'Administrador Geral', value: AuthorizationRelations.GeneralAdmin }
]

export class ScheduleManagementStrategy implements ModuleTypeStrategy {
  getPermissionsForNewUsers(): PermissionOption[] {
    return PERMISSIONS_FOR_NEW_USERS
  }

  getPermissionsForSelect(): PermissionOption[] {
    return PERMISSIONS_FOR_SELECT
  }

  getDefaultPermission(): AuthorizationRelations {
    return AuthorizationRelations.BasicEditor
  }

  resolveResourceType(base: AuthorizationResourcesAndSubjects): AuthorizationResourcesAndSubjects {
    return base
  }

  async addPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    await Network.permission.addPermissions(resourceId, resourceType, payload, companyId)
  }

  async upsertPermissions(
    resourceId: number,
    companyId: number,
    payload: UpsertPermissionsRequest,
    resourceType: AuthorizationResourcesAndSubjects
  ): Promise<void> {
    await Network.permission.upsertPermissions(resourceId, resourceType, payload, companyId)
  }
}
